import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import ObservableEntity from "../../../../../server/com/silkplm/engine/entities/ObservableEntity.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.engine.entities.BusinessRecord';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class BusinessRecord extends ObservableEntity {

    /**
     *  @class BusinessRecord
     *  @alias module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.EID = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {string}  */
        this.id = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {number}  */
        this.version = null;

    }





    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord}
     */
    withVersion(val){
        this.version = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.engine.entities.BusinessRecord';
metadata.__type_short__ = 'BusinessRecord';
BusinessRecord.prototype.__metadata__ = metadata;

BusinessRecord.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/engine/entities/BusinessRecord */
export default BusinessRecord

export { BusinessRecord }
